import CrudPage from "@/components/CrudPage";
import { useAuth } from "@/contexts/AuthContext";

export default function Machines() {
  const { user } = useAuth();
  const canWrite = ["Owner", "ProductionManager"].includes(user?.role);
  return (
    <CrudPage
      eyebrow="Master data"
      title="Machines"
      description="Roasters in the production line."
      testIdPrefix="machines"
      resource="machines"
      canWrite={canWrite}
      emptyHint="Add your Genio (or other) roasters."
      columns={[
        { key: "name", label: "Name" },
        { key: "serial_number", label: "Serial" },
        { key: "capacity_kg", label: "Capacity (kg)", align: "right" },
        { key: "location", label: "Location" },
      ]}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "serial_number", label: "Serial number" },
        { key: "capacity_kg", label: "Capacity (kg)", type: "number" },
        { key: "location", label: "Location" },
      ]}
    />
  );
}
